import { supabase } from '@/lib/supabase'
import type { Trip } from '@/services/tripService'
import type { Day } from '@/services/dayService'
import type { Activity } from '@/services/activityService'

export async function getSharedTrip(token: string): Promise<Trip | null> {
  const { data, error } = await supabase.rpc('get_shared_trip', { p_token: token })
  if (error) throw error
  return data?.[0] ?? null
}

export async function getSharedTripDays(token: string): Promise<Day[]> {
  const { data, error } = await supabase.rpc('get_shared_trip_days', { p_token: token })
  if (error) throw error
  return data
}

export async function getSharedTripActivities(token: string): Promise<Activity[]> {
  const { data, error } = await supabase.rpc('get_shared_trip_activities', { p_token: token })
  if (error) throw error
  return data
}
